import styled, { css } from 'styled-components';

const commonInputStyles = css`
  display: flex;
  align-items: center;
  padding: 4px 12px;
  border: ${(props) => (props.noborder ? 'none' : '1px solid')};
  border-radius: 4px;
  background-color: ${(props) => (props.disabled ? '#F5F6F9' : '#FFFFFF')};
  border-color: ${(props) => (props.hasError ? '#FF4D4F' : '#ebebeb')};
`;

const labelStyles = css`
  width: ${(props) => props.labelWidth}px;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  color: ${(props) => (props.hasError ? '#FF4D4F' : '#333333')};
  flex-shrink: 0;
`;
export const AntdInputStyles = styled.div`
  ${commonInputStyles}
  .init-label {
    ${labelStyles}
  }
  input {
    flex: 1;
  }
  .ant-input-number-group-addon {
    border: none;
    background-color: transparent;
    color: #333333;
  }
`;
export const AntdTextAreaStyles = styled.div`
  ${commonInputStyles}
  align-items: flex-start;
  /* padding-bottom: 20px; */
  .init-label {
    ${labelStyles}
    height: 29px;
    line-height: 29px;
  }
  .ant-input-textarea {
    flex: 1;
  }
`;
export const AntdDatePickerStyles = styled.div`
  ${commonInputStyles}
  .init-label {
    ${labelStyles}
    flex-shrink: 0;
  }
  .ant-picker {
    flex: 1;
  }
`;
export const AntdSelectStyles = styled.div`
  ${commonInputStyles}
  .init-label {
    width: 52px;
    ${labelStyles}
  }
  .ant-select {
    flex: 1;
  }
  .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer)
    .ant-select-selector {
    border: none !important;
  }
`;
export const AntdRadioStyles = styled.div`
  ${(props) => (props.wrapStyle ? commonInputStyles : '')}
  border: none;
  padding: 0;
  .init-label {
    width: 52px;
    ${labelStyles}
  }
  .ant-radio-group {
    flex: 1;
    margin-left: 12px;
  }
`;

export const AntdCheckboxStyles = styled.div`
  ${(props) => (props.wrapStyle ? commonInputStyles : '')}
  .init-label {
    ${labelStyles}
  }
  .ant-checkbox-group {
    flex: 1;
    margin-left: 0;
  }
`;
